import { CustomButton } from '../../../../features/customButton';
import useOpenModalWithClothes from '../../../../../hooks/shared/quests/useOpenModalWithClothes';
import useIsHasClothInPrize from '../../../../../hooks/shared/quests/useIsHasClothInPrize';
import { reset } from '../../../../../utils/events/events';
import { useQuestPrize } from '../../../../../hooks/shared/quests/useQuestPrize';
import content from '../../constants/content';
import classNames from 'classnames';

const { buttonOpenModalWithClothes } = content;

export default function ChallengeShowPrizeClothesButton({ challengeData }) {
  const { mainPrize } = useQuestPrize(challengeData);
  const isHasCloth = useIsHasClothInPrize(mainPrize);
  const openModalWithClothes = useOpenModalWithClothes();
  return (
    isHasCloth && (
      <CustomButton {...buttonOpenModalWithClothes} onClick={(e) => reset(e, () => openModalWithClothes(mainPrize))} />
    )
  );
}
